import {
  Button,
  Pagination,
  Table,
  Tag,
  Input,
  Switch,
  Space,
  Popconfirm,
  message,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
import "animate.css";
import { useNavigate } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import { DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { MdAdd } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";
import { getCity, getstate } from "./StateCityApi";
import AddStateCity from "./AddStateCity";

const StateCity = () => {
  const [stateData, setStateData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [from, setFrom] = useState("addState");
  const [filldata, setFilldata] = useState({});
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [cityData, setCityData] = useState([]);
  const searchInput = useRef(null);
  const pageSize = 10;

  function FetchState(currentPage) {
    setIsLoading(true);
    getstate(`?page=${currentPage}&limit=10`)
      .then((response) => {
        if (response.status) {
          setStateData(response?.data.data?.states);
          setCurrentPage(response.data?.data?.currentPage);
          setTotalPages(response.data?.data?.totalPages);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchState(currentPage);
  }, [currentPage, searchText, searchedColumn]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };

  const onRowExpand = async (record) => {
    setIsLoading(true);

    await getCity(`limit=999999`)
      .then((response) => {
        if (response.data.status) {
          const expandedData = response.data?.data?.cities
            .filter((item) => item.stateId === record.id)
            .map((item) => ({
              ...item,
            }));

          setCityData(expandedData || []);
        }
      })
      .catch((err) => {
        console.error("Error fetching subcategories", err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const columnCity = [
    {
      title: "City Name",
      dataIndex: "name",
      key: "name",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <p className="text-xs font-poppins">{record.name}</p>
      ),
    },
    {
      title: "Created Date",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <p className="text-xs font-poppins">
          {ExtractDate(record.createdAt)}•{ExtractTime(record.createdAt)}
        </p>
      ),
    },
  ];

  const renderNestedTable = (record, index) =>
    cityData.length > 0 ? (
      <Table
        columns={columnCity}
        dataSource={cityData}
        pagination={false}
        size="small"
        className="custom-table-header"
        rowKey="uuid"
      />
    ) : (
      <p className="text-gray-400 flex justify-center items-center">
        No subcategories Found
      </p>
    );

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    setCurrentPage(1);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: "white",
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columnState = [
    {
      title: "SNo.",
      dataIndex: "serial",
      key: "serial",
      className: "custom-header font-poppins text-xs",
      render: (data, record, index) => {
        return (
          <p className="text-xs font-poppins text-rgbaprimary9 font-semibold">
            {index + 1 + (currentPage - 1) * pageSize}.
          </p>
        );
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {record.name?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
            </p>
          </>
        );
      },
    },

    {
      title: "Add City",
      dataIndex: "add",
      key: "add",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p
              className="text-xs font-poppins font-bold w-1/2 text-center rounded-full cursor-pointer text-rgbaprimary9"
              title="View details"
              onClick={() => {
                setFrom("addCity");
                setFilldata(record);
                setOpenModal(true);
              }}
            >
              <MdAdd />
            </p>
          </>
        );
      },
    },
  ];

  return (
    <div>
      <ComponentTitle title={"State List "} />
      <div className="flex items-end justify-end mb-4">
        {/* <Search
          placeholder="search  here..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "25%" }}
        /> */}
        <p
          onClick={() => {
            setOpenModal(true);
            setFrom("addState");
          }}
          className="bg-rgbaprimary9 cursor-pointer text-white text-sm p-2 hover:bg-rgbaprimary8"
        >
          Add State
        </p>
      </div>

      <div
        style={{ maxHeight: "540px", overflow: "auto" }}
        className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px]"
      >
        <Table
          className="w-screen sm:w-screen custom-table-header"
          loading={isLoading}
          size="small"
          columns={columnState}
          rowKey="id"
          expandable={{
            expandedRowKeys: expandedRowKeys,
            onExpand: (expanded, record) =>
              expanded
                ? (setExpandedRowKeys([record.id]), onRowExpand(record))
                : (setExpandedRowKeys([]), onRowExpand()),
            expandedRowRender: (_record, index) =>
              renderNestedTable(_record, index),
            rowExpandable: (record) => true,
          }}
          dataSource={stateData}
          pagination={false}
        />
      </div>
      <Pagination
        className="mt-2 text-xs w-full flex justify-center items-center"
        onChange={handlePageChange}
        current={currentPage}
        defaultCurrent={1}
        total={10 * totalPage}
        showSizeChanger={false}
        pageSize={pageSize}
      />
      {openModal && (
        <AddStateCity
          isOpen={openModal}
          setIsOpen={setOpenModal}
          Fill={filldata}
          setFill={setFilldata}
          from={from}
          currentPage={currentPage}
          apiCall={from === "addState" ? FetchState : onRowExpand}
          // addingCategory={addCategory}
          // addSubcategory={addSubcategory}
        />
      )}
    </div>
  );
};
export default StateCity;
